module.exports = __webpack_public_path__ + "img/Background4.48a6b2a3.jpg";